module.exports = __webpack_public_path__ + "img/bnaner2-home-min.371c2d6c.png";